// @flow
import React from 'react';

import { AuthAsideBase } from 'pages/authPage/Layout/StyledComponents';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

import { styled, useTheme } from '@mui/material/styles';

import bg from 'pages/authPage/Layout/AuthAside/Autodok/images/bg.svg';
import headLogo from 'pages/authPage/Layout/AuthAside/Autodok/images/headLogo.svg';

const AuthAside = styled(AuthAsideBase)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  backgroundImage: `url("${bg}")`,
  backgroundPosition: 'bottom right',
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  width: '40%',
}));

const AuthAsideAutodok = () => {
  const {
    labelOptions: { loginNameImg, loginPoweredBy },
  } = useTheme();

  return (
    <AuthAside>
      <Box mx="auto" my={2} width="160px">
        <img src={headLogo} alt={loginNameImg.alt} width="100%" />
      </Box>
      <Box m="auto" width="300px">
        <img src={loginNameImg.src} alt={loginNameImg.alt} width="100%" />
      </Box>
      {loginPoweredBy && (
        <Box mx="auto" mb={1}>
          <Link href="https://www.dokka.com" target="blank" sx={{ color: 'common.white' }}>
            Powered by DOKKA
          </Link>
        </Box>
      )}
    </AuthAside>
  );
};

export default AuthAsideAutodok;
